import React from 'react'

export default function Contact() {
  return (
    <div className='container contact ' >
        <h2 id="h2">CONTACT</h2>
        <p id="p">Address:<br></br>
        South Eastern Railway Mixed Higher Secondary School, Adra
        P.O. Adra, Dist. – Purulia (West Bengal)
        PIN – 723121
        <br></br>
        Phone No: 03251-245900 (P&T); 82301 (Railway)
        <br></br>
        Website: www.sermhssadra.com
        <br></br>
        Email: sermhssadra01@gmail.com
        </p>
        <iframe
        className='my-4'
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3658.973235600621!2d86.6747364!3d23.4974735!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f6f19967b5a5fd%3A0xa2e466608a1a5c85!2sS%20E%20Railway%20mixed%20High%20school%20campus-1!5e0!3m2!1sen!2sin!4v1697096450990!5m2!1sen!2sin" width="100%" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
  )
}
